import React from 'react';
import { styled } from '@glitz/react';
import ProductFeatureViewModel from 'Product/ProductFeature/ProductFeatureViewModel.type';
import { OverlayNotABackdrop } from 'Shared/SharedComponents/atoms/AspectRatio';
import { AspectImageVideoBackground } from 'Shared/SharedComponents/molecules/ImageVideoBackground';
import { Paragraph, ResponsiveSize, ResponsiveLineHeight } from 'Shared/SharedComponents/atoms/Typography';
import connect from 'Shared/connect';
import { selectDeviceImage } from 'Shared/utils';
import { isCompact } from 'Shared/Viewport';
import { PictureImage, Preset } from 'Shared/Image';
import * as style from 'Shared/Style';

type PropType = {
  className?: string;
  feature: ProductFeatureViewModel;
  currentBreakpoint: number;
};

const Wrap = styled.div({
  color: style.colors.monochrome.black,
})

const Overlay = styled(OverlayNotABackdrop, {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

const Image = styled.img({
  width: '88px', height: '88px'
})

const ContentWrap = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  marginTop: '16px',
})

const Heading = styled.span({
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '100%',
  textTransform: 'uppercase',
  display: 'block',
})

const FeatureImage = styled(PictureImage, {
  position: 'absolute',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center center',
  borderRadius: '8px'
});

export const ProductFeature = connect((state) => {
  return {
    currentBreakpoint: state.currentBreakpoint,
  };
})((props: PropType) => {
  const { feature } = props;
  const isMobile = isCompact(props.currentBreakpoint);
  const deviceImage = selectDeviceImage(feature.backgroundImage, feature.backgroundImageSmallScreen, isMobile);

  return (
    <Wrap className={props.className}>
      <div>
        <AspectImageVideoBackground
          paddingTop={'100%'}
          videoSources={feature.backgroundVideoSources}
          borderRadius={8}
          breakPoint={props.currentBreakpoint}
        >
          {deviceImage && (
            <FeatureImage src={deviceImage?.url} />
          )}
          <Overlay
            css={{
              ...(feature.imageFilter && {
                backgroundColor: style.colors.rgbaFilters.blue,
                borderRadius: '8px',
              })
            }}
          >
            {feature.icon?.url && (
              <Image src={feature.icon?.url} />
            )}
          </Overlay>
        </AspectImageVideoBackground>
      </div>
      <ContentWrap>
        <Heading>
          {feature.heading}
        </Heading>
        <Paragraph fontSize={ResponsiveSize.D16_M16} lineHeight={ResponsiveLineHeight.D130_M130}>
          {feature.text}
        </Paragraph>
      </ContentWrap>
    </Wrap>
  );
});

export default ProductFeature;
